import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import http from '../../commonFunctions/httpClient'
import { getLocalValue, LoacalVariables } from '../../commonFunctions/CommonFunctions';

const Logout: React.FC = () => {
    const navigate = useNavigate();

    const [token, setToken] = useState<string | null>(localStorage.getItem('token'));
    useEffect(() => {
        async function logout() {
            try {
                const userId = getLocalValue(LoacalVariables.LoginUserId) || getLocalValue(LoacalVariables.UserId);
                const response = await http.post(`Auth/logout/${userId}`, {});
            }
            catch (e) {

            }

        }
        logout();
        localStorage.removeItem('token');
        localStorage.clear()
        setToken(null)
        http.setAuthToken(null);
        navigate('/login');
        window.location.reload();
    }, [navigate]);

    return <div>Logging out...</div>;
};

export default Logout;
